import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "search-field" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("svg", {
  class: "icon-search",
  viewbox: "0 0 24 24",
  width: "23",
  height: "23"
}, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "#header-icon-search" })
], -1 /* HOISTED */)
const _hoisted_3 = ["onKeyup"]
const _hoisted_4 = ["aria-label"]

import { inject, ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'SearchBar',
  props: {
    searchTerm: {}
  },
  emits: ["search"],
  setup(__props: any, { emit }) {

const props = __props;





const i18n = inject('i18n') as { [key: string]: string };
const searchTerm = ref(props.searchTerm);
if (searchTerm.value === '*') {
    searchTerm.value = '';
}
const inputId = 'search-' + (Math.random() + 0.1).toString(36).substring(2, 5);

function search (): void {
    emit('search', searchTerm.value.toString().trim());
}

function checkIfInputEmpty (): void {
    if (!searchTerm.value.toString().trim()) {
        search();
    }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("label", {
      for: inputId,
      class: "visually-hidden"
    }, _toDisplayString(_unref(i18n).searchTerm) + ":", 1 /* TEXT */),
    _withDirectives(_createElementVNode("input", {
      id: inputId,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchTerm).value = $event)),
      type: "search",
      onKeyup: [
        _withKeys(search, ["enter"]),
        checkIfInputEmpty
      ]
    }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_3), [
      [_vModelText, searchTerm.value]
    ]),
    _createElementVNode("button", {
      class: "search-field-submit button-icon",
      "aria-label": _unref(i18n).search,
      onClick: search
    }, null, 8 /* PROPS */, _hoisted_4)
  ]))
}
}

})